import { AuthService } from '@auth/auth.service';
import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';

@Component({
    selector: 'dockmail',
    templateUrl: 'dockmail.component.html',
    styleUrls: ['dockmail.component.scss']
})
export class DockMailComponent implements OnInit, OnChanges {
    @Input() public editMode;
    @Input() public userList: any[];

    @Input()
    @Output()
    public destList: any[];

    @Output()
    public onAddItem: EventEmitter<any> = new EventEmitter();
    @Output()
    public onDelItem: EventEmitter<any> = new EventEmitter();

    public fr: any;

    constructor(protected _messageService: MessagesService, private auth: AuthService) {}

    public ngOnInit() {}

    public ngOnChanges() {}

    public initialize() {}

    public moveToTarget(event) {
        this.onAddItem.emit(event);
    }

    public moveToSource(event) {
        this.onDelItem.emit(event);
    }
}
